if (!customElements.get("slide-show")) {
  class t extends HTMLElement {
    constructor() {
      super(), window.initLazyScript(this, this.init.bind(this));
    }
    init() {
      (this.slideshow = this.querySelector(".slideshow")),
        (this.slides = this.querySelectorAll(".slideshow__slide")),
        (this.nav = this.querySelector(".slideshow-nav")),
        (this.pagination = this.querySelector(".slideshow-pagination")),
        (this.rtl = "rtl" === document.dir),
        (this.currentIndex = 0),
        (this.swipeThreshold = 80),
        (this.wheelTriggerWait = 800),
        this.nav &&
          ((this.counterCurrent = this.querySelector(
            ".slideshow-nav__counter-current"
          )),
          this.nav.addEventListener("click", this.handleNavClick.bind(this))),
        this.pagination &&
          ((this.pageBtns = this.querySelectorAll(".page-btn")),
          this.pagination.addEventListener(
            "click",
            this.handlePaginationClick.bind(this)
          )),
        theme.device.hasTouch &&
          (this.slideshow.addEventListener(
            "touchstart",
            this.handleTouchStart.bind(this),
            { passive: !0 }
          ),
          this.slideshow.addEventListener(
            "touchmove",
            debounce(this.handleTouchMove.bind(this), 200),
            { passive: !0 }
          )),
        this.slideshow.addEventListener("wheel", this.handleWheel.bind(this), {
          passive: !0,
        }),
        this.slideshow.addEventListener("transitionend", t.handleTransitionend),
        this.setSlideVisibility(),
        "true" === this.dataset.autoplay && this.initAutoPlay();
    }
    initAutoPlay() {
      (this.autoplayEnabled = !0),
        (this.autoplaySpeed = 1e3 * this.dataset.speed),
        this.addEventListener("mouseover", this.pauseAutoplay.bind(this)),
        this.addEventListener("mouseleave", this.resumeAutoplay.bind(this)),
        this.slideshow.addEventListener(
          "focusin",
          this.pauseAutoplay.bind(this)
        ),
        this.slideshow.addEventListener(
          "focusout",
          this.resumeAutoplay.bind(this)
        ),
        this.addObserver(),
        this.startAutoplay();
    }
    handleNavClick(t) {
      if (t.target.matches(".autoplay-btn")) {
        this.togglePlayState(t);
        return;
      }
      "next" === t.target.name
        ? this.showNextSlide()
        : "prev" === t.target.name && this.showPrevSlide();
    }
    handlePaginationClick(t) {
      t.target.matches(".page-btn") &&
        ((this.autoplayTimeLeft = this.autoplaySpeed),
        this.setActiveSlide(Number(t.target.dataset.index)));
    }
    handleWheel(t) {
      this.blockWheelTrigger
        ? t.preventDefault()
        : t.deltaX > 20
        ? (t.preventDefault(),
          this.showNextSlide(),
          (this.blockWheelTrigger = !0),
          setTimeout(() => {
            this.blockWheelTrigger = !1;
          }, this.wheelTriggerWait))
        : t.deltaX < -20 &&
          (t.preventDefault(),
          this.showPrevSlide(),
          (this.blockWheelTrigger = !0),
          setTimeout(() => {
            this.blockWheelTrigger = !1;
          }, this.wheelTriggerWait));
    }
    handleTouchStart(t) {
      this.touchStart = t.changedTouches[0].screenX;
    }
    handleTouchMove(t) {
      let e = t.changedTouches[0].screenX;
      e < this.touchStart - this.swipeThreshold &&
        (this.rtl ? this.showPrevSlide() : this.showNextSlide()),
        e > this.touchStart + this.swipeThreshold &&
          (this.rtl ? this.showNextSlide() : this.showPrevSlide());
    }
    static handleTransitionend(t) {
      t.target.matches(".has-motion") &&
        t.target.classList.remove("transition-out");
    }
    showNextSlide() {
      let t = this.currentIndex + 1;
      t === this.slides.length && (t = 0), this.setActiveSlide(t, "next");
    }
    showPrevSlide() {
      let t = this.currentIndex - 1;
      t < 0 && (t = this.slides.length - 1), this.setActiveSlide(t, "prev");
    }
    setActiveSlide(t, e) {
      if (t === this.currentIndex) return;
      clearTimeout(this.setActiveSlideTimeoutId),
        clearTimeout(this.autoplayTimer);
      let i = e || (t < this.currentIndex ? "prev" : "next");
      this.rtl && (i = "next" === i ? "prev" : "next"),
        (this.dataset.direction = i),
        this.slides[this.currentIndex].classList.add("transition-out"),
        (this.setActiveSlideTimeoutId = setTimeout(() => {
          this.slideshow.scrollTo({
            left: this.slides[t].offsetLeft,
            behavior: "auto",
          }),
            this.slides[t].classList.add("is-active"),
            this.slides[this.currentIndex].classList.remove(
              "is-active",
              "transition-out"
            );
          let e = this.slides[this.currentIndex].querySelector(".has-motion");
          e && e.classList.add("transition-out"),
            this.autoplayEnabled && (this.autoplayStartTime = Date.now()),
            this.counterCurrent && (this.counterCurrent.textContent = t + 1),
            (this.currentIndex = t),
            this.setSlideVisibility(),
            this.updatePagination(),
            this.autoplayEnabled &&
              !this.autoplayPaused &&
              ((this.autoplayTimeLeft = this.autoplaySpeed),
              (this.autoplayTimer = setTimeout(
                this.showNextSlide.bind(this),
                this.autoplaySpeed
              )));
        }, 200));
    }
    updatePagination() {
      this.pagination &&
        this.pageBtns.forEach((t, e) => {
          e === this.currentIndex
            ? t.setAttribute("aria-current", "true")
            : t.removeAttribute("aria-current");
        });
    }
    stopAutoplay() {
      this.setSlideshowState("paused"), clearTimeout(this.autoplayTimer);
    }
    startAutoplay() {
      (this.autoplayTimeLeft = null),
        (this.autoplayStartTime = Date.now()),
        clearTimeout(this.autoplayTimer),
        (this.autoplayTimer = setTimeout(
          this.showNextSlide.bind(this),
          this.autoplaySpeed
        )),
        this.setSlideshowState("running");
    }
    pauseAutoplay() {
      this.autoplayEnabled &&
        !this.autoplayPaused &&
        (this.stopAutoplay(),
        this.autoplayTimeLeft
          ? (this.autoplayTimeLeft -= Date.now() - this.resumedTime)
          : (this.autoplayTimeLeft =
              this.autoplaySpeed - (Date.now() - this.autoplayStartTime)));
    }
    resumeAutoplay() {
      this.autoplayEnabled &&
        this.autoplayPaused &&
        ((this.resumedTime = Date.now()),
        (this.autoplayTimer = setTimeout(
          this.showNextSlide.bind(this),
          this.autoplayTimeLeft
        )),
        this.setSlideshowState("running"));
    }
    addObserver() {
      if ("IntersectionObserver" in window == !1) return;
      let t = new IntersectionObserver((t) => {
        t.forEach((t) => {
          t.isIntersecting ? this.resumeAutoplay() : this.pauseAutoplay();
        });
      });
      t.observe(this);
    }
    setSlideVisibility() {
      this.slides.forEach((t, e) => {
        let i = t.querySelectorAll("a");
        e === this.currentIndex
          ? (t.setAttribute("aria-hidden", "false"),
            t.removeAttribute("tabindex"),
            i.forEach((t) => {
              t.removeAttribute("tabindex");
            }))
          : (t.setAttribute("aria-hidden", "true"),
            t.setAttribute("tabindex", "-1"),
            i.forEach((t) => {
              t.setAttribute("tabindex", "-1");
            }));
      });
    }
    setSlideshowState(t) {
      this.style.setProperty("--play-state", t),
        this.slideshow.setAttribute(
          "aria-live",
          "running" === t ? "off" : "polite"
        ),
        (this.autoplayPaused = "paused" === t);
    }
    togglePlayState(t) {
      t.target.classList.toggle("is-paused"),
        (this.autoplayEnabled = !this.autoplayEnabled),
        (this.dataset.autoplay = this.autoplayEnabled ? "true" : "false"),
        this.autoplayEnabled ? this.startAutoplay() : this.stopAutoplay();
    }
  }
  customElements.define("slide-show", t);
}
